import i18n from '@/plugins/i18n';

const mssqlQueryPerformanceTableHeaders = () => [
  {
    key: 'name',
    name: i18n.global.t('dbm.query.query'),
    width: '55%',
  },
  {
    key: 'count',
    name: i18n.global.t('dbm.query.totalExicution'),
    width: '15%',
    sortable: true,
  },
  {
    key: 'value',
    name: i18n.global.t('dbm.query.executionTime'),
    width: '15%',
    sortable: true,
  },
  {
    key: 'timestamp',
    name: i18n.global.t('dbm.query.timestamp'),
    width: '15%',
    sortable: true,
  },
];

export { mssqlQueryPerformanceTableHeaders };
